import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { ModalidadI } from "interfaces/Modalidad";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createModalidadSchema } from "schemas/modalidad/CreateModalidadSchema";
import { postModalidad, putModalidad } from "services/modalidad";
import { RootState } from "store/store";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: ModalidadI;
  onSuccess?: (titulo: ModalidadI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
}

export const ModalidadABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newModalidad = await postModalidad({ params });
      showSuccessToast("¡La modadlidad fue creado con éxito!");
      if (onSuccess) onSuccess(newModalidad);
      onClose();
    } catch (err: any) {
      showErrorToast("La modadlidad no pudo ser creado.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newModalidad = await putModalidad({ params });
      showSuccessToast("La modadlidad fue editado con éxito!");
      if (onSuccess) onSuccess(newModalidad);
      onClose();
    } catch (err: any) {
      showErrorToast("La modadlidad no pudo ser creado.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createModalidadSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Modalidad" : "Nueva Modalidad"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={12}>
                  <Input
                    id={"nombre"}
                    title="Nombre de la modalidad"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
